import {LOCALE_SOURCE, getValidUpRefCookie, updateUpRefCookieData} from './upRefCookieHelpers';

const
      /**
       * @param {import('#api/services/cookie/upRefCookieService').UpRefCookieData} upRefCookie
       * @returns {boolean}
       */
      isGeoRedirectTooltipActive = (upRefCookie) => (
	      upRefCookie.localeSource === LOCALE_SOURCE.GEO
      ),

      markLocaleSourceAsUser = () => {
	      updateUpRefCookieData({'localeSource': LOCALE_SOURCE.USER});
      },

      /**
       * @param {string} currentSiteLocale
       */
      persistActiveLocaleAsPreference = (currentSiteLocale) => {
	      const upRefCookie = getValidUpRefCookie();

	      if (
		      upRefCookie.localeSource === LOCALE_SOURCE.USER &&
		      upRefCookie.locale !== currentSiteLocale
	      ) {
		      updateUpRefCookieData({'locale': currentSiteLocale});
	      }
      },

      /**
       * @param {Event} event
       */
      handleLanguagePopoverClick = (event) => {
	      if (event.target.closest('.languageSelectorPopover a')?.href) {
		      markLocaleSourceAsUser();
	      }
      };

export {
	isGeoRedirectTooltipActive,
	markLocaleSourceAsUser,
	persistActiveLocaleAsPreference,
	handleLanguagePopoverClick
};